<!--
 * @Description: 解压申请
 * @Author: 胡博君
 * @Date: 2019-12-14 18:49:34
 * @LastEditors  : 胡博君
 * @LastEditTime : 2019-12-26 16:01:20
 -->
<template>
  <div class="loan-decompression-apply">
    <div class="tips">您正在进行解押申请，请选择办理方式</div>
    <div
      @click="linkMedia(0)"
      class="router router--bg" v-if="handType =='1' || handType =='2'">
      <div class="router__left">
        <div class="router__left-top">
          <div class="router__title">请中介代办</div>
          <div class="router__tag">更省心</div>
        </div>
        <div class="router__tips">代办人帮车主办好解押手续后，将资料交给车主</div>
      </div>
      <cz-icon color="#FF8E52" size="22" name="right-circle-fill" />
    </div>
    <div
      @click="linkMedia(1)"
      class="router" v-if="handType =='1' || handType =='3'">
      <div class="router__left">
        <div class="router__left-top">
          <div class="router__title">自己办理</div>
        </div>
        <div class="router__tips">车主收到资料后，自行前往属地车管所办理</div>
      </div>
      <cz-icon color="#FF8E52" size="22" name="right-circle-fill" />
    </div>
  </div>
</template>
<script>

  export default {
  data(){
    return {
      id: '',
      handType:'1'
    }
  },
  mounted() {
    this.id = this.$route.query.id || '';
    this.handType = this.$route.query.handType;
  },
  methods: {
    linkMedia(self) {
      this.$router.push(`/loan/pay?id=${this.id}&applicationType=1&self=${self}`);
    }
  }
}
</script>
<style lang="scss" scoped>
.loan-decompression-apply {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px;
  .tips {
    padding-bottom: 47px;
    color: #9ca2ad;
    font-size: 28px;
  }
  .router {
    margin: 0 auto;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    width: 100%;
    height: 148px;
    padding-right: 32px;
    box-sizing: border-box;
    box-shadow: 0 0 12px 0 rgba(225,225,225,0.50);
    background: #fff;
    &--bg {
      background-image: linear-gradient(-65deg, #FDECE6 7%, #FFFFFF 100%, #FCF1DA 100%);
    }
    &__left {
      flex: 1;
      box-sizing: border-box;
      padding-left: 34px;
      &-top {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
      }
    }
    &__title {
      margin-right: 26px;
      font-size: 28px;
      color: #333333;
    }
    &__tag {
      padding: 6px;
      color: #FF8E52;
      border: 1Px solid #FF8E52;
      border-radius: 4px;
      font-size: 22px;
    }
    &__tips {
      font-size: 24px;
      color: #999999;
    }
  }
}
</style>
